export default __webpack_public_path__ + "static/media/l-icon.98b380fb.svg";